var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8334 10.75V14.25C13.8334 17.1667 12.6667 18.3334 9.75008 18.3334H6.25008C3.33341 18.3334 2.16675 17.1667 2.16675 14.25V10.75C2.16675 7.83335 3.33341 6.66669 6.25008 6.66669H9.75008C12.6667 6.66669 13.8334 7.83335 13.8334 10.75Z",
    fill: "#2E9973"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 1.66669H11.25C8.7466 1.66669 7.53846 2.53234 7.246 4.61577C7.16858 5.16727 7.63004 5.62502 8.18695 5.62502H9.75005C13.25 5.62502 14.875 7.25002 14.875 10.75V12.3131C14.875 12.87 15.3328 13.3315 15.8843 13.2541C17.9677 12.9616 18.8334 11.7535 18.8334 9.25002V5.75002C18.8334 2.83335 17.6667 1.66669 14.75 1.66669Z",
    fill: "#2E9973"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.adeb07d0f5cc9a8ca9c49bd60f2ec265.svg";
export { ForwardRef as ReactComponent };